import React from 'react';
import {useTranslation} from 'react-i18next';
import {DimensionsFiltersComponent} from '../../data_explorer/DimensionsFiltersComponent';

/**
 * La fila FILTROS de los Ajustes: el componente de filtros del Explorador (importado, sin
 * tocar), con la etiqueta del mockup. Los filtros son SIEMPRE Ajustes del informe, nunca de la
 * plantilla — formato Looker Studio `[[{fieldName, values, type, operator}]]`.
 */
export function FiltersRow({fieldsData, sourceType, filters, onChange}) {
    const {t} = useTranslation();
    return (
        <div className="inf-settings-row inf-filters-row">
            <span className="inf-settings-label">{t('informes.settings.filters', 'Filtros')}</span>
            <div className="inf-filters-body">
                <DimensionsFiltersComponent
                    fieldsData={fieldsData}
                    sourceType={sourceType}
                    filters={filters || []}
                    onFiltersChange={onChange}
                />
            </div>
        </div>
    );
}
